import React, { useState } from "react";
import { ScoodleDefaultPage } from "../../../04templates/scoodle/defaultPage/ScoodleDefaultPage";
import { Body3, H1 } from "pu-crossproduct-components/build/components/Atoms/Type";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import { Button, ButtonColors, Size } from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import { Link, LinkColors } from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import bol1 from "./bol_1.svg";
import bol2 from "./bol_2.svg";
import bol3 from "./bol_3.svg";
import styled from "styled-components";
import {Scoodle2FAExplanation} from "../Scoodle2FAExplanation/Scoodle2FAExplanation";

const Bol = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;    

    & img {
        width: 200px;
        height: 200px;
    }

    & p {
        text-align: center;
        font-weight: bold;
        max-width: 200px;
    }
`

const ButtonContainer = styled.div`
    button {
        width: 383px;
    }
`;

interface IScoodle2FASetup {
    accountName : string,
    onStartSetup : () => void;
}

export const Scoodle2FASetup: React.FC<IScoodle2FASetup> = props => {
    const { t } = useTranslation();
    const [explanationOpen, setExplanationOpen] = useState<boolean>(false)

    return <ScoodleDefaultPage>
        <H1>{t('twoFactorScoodleSetupTitle')}</H1>
        <Body3>{t('twoFactorScoodleSetupBody', {accountName: props.accountName})}</Body3>
        <br/>

        <GridContainer>
            <GridRow>
                <GridItem col={0} laptop={1}/>
                <GridItem col={12} laptop={3}>
                    <Bol>
                        <img src={bol1} />
                        <p>{t('twoFactorScoodleSetupBol1')}</p>
                    </Bol>
                </GridItem>

                <GridItem col={12} laptop={4}>
                    <Bol>
                        <img src={bol2} />
                        <p>{t('twoFactorScoodleSetupBol2')}</p>
                    </Bol>
                </GridItem>

                <GridItem col={12} laptop={3}>
                    <Bol>
                        <img src={bol3} />
                        <p>{t('twoFactorScoodleSetupBol3')}</p>
                    </Bol>
                </GridItem>
            </GridRow>
        </GridContainer>

        <br/>

        <ButtonContainer>
            <Button onClick={props.onStartSetup} size={Size.large}>{t('twoFactorScoodleSetupStartButton')}</Button><br />            
        </ButtonContainer>
        
        <Link color={LinkColors.primary} onClick={() => setExplanationOpen(true)}>{t('twoFactorScoodleSetupExplanationLink')}</Link>

        <Scoodle2FAExplanation open={explanationOpen} onClose={() => setExplanationOpen(false)} />
    </ScoodleDefaultPage>
}